import {
  LucideBell,
  LucideBox,
  LucideChevronDown,
  LucideChevronRight,
  LucideCircleAlert,
  LucideCircleQuestionMark,
  LucideCode,
  LucideCreditCard,
  LucideDownload,
  LucideDynamicIcon,
  LucideFileText,
  LucideFocus,
  LucideGitMerge,
  LucideInfo,
  LucideLayers,
  LucideLayoutList,
  LucideLink,
  LucideMaximize,
  LucideMessageCircle,
  LucideMessageSquare,
  LucideNetwork,
  LucideRedo,
  LucideSearch,
  LucideServer,
  LucideSettings,
  LucideShield,
  LucideTrash2,
  LucideUndo,
  LucideUser,
  LucideUsers,
  LucideZoomIn,
  LucideZoomOut,
} from "@lucide/angular";

/**
 * Every leaf Lucide icon class registered with the app. Pass via
 * `provideLucideIcons(...LUCIDE_ICON_SET)` in app.config so dynamic
 * `<svg [lucideIcon]="kebabName">` lookups can resolve any of them.
 *
 * Excludes LucideDynamicIcon — that's the resolver component, not an icon.
 * Add new icons here as they're needed; that single edit propagates to
 * every consumer.
 */
export const LUCIDE_ICON_SET = [
  LucideBell,
  LucideBox,
  LucideChevronDown,
  LucideChevronRight,
  LucideCircleAlert,
  LucideCircleQuestionMark,
  LucideCode,
  LucideCreditCard,
  LucideDownload,
  LucideFileText,
  LucideFocus,
  LucideGitMerge,
  LucideInfo,
  LucideLayers,
  LucideLayoutList,
  LucideLink,
  LucideMaximize,
  LucideMessageCircle,
  LucideMessageSquare,
  LucideNetwork,
  LucideRedo,
  LucideSearch,
  LucideServer,
  LucideSettings,
  LucideShield,
  LucideTrash2,
  LucideUndo,
  LucideUser,
  LucideUsers,
  LucideZoomIn,
  LucideZoomOut,
];

/**
 * Drop-in replacement for the legacy `LucideAngularModule`. Spread into
 * any standalone component's `imports:` to enable both static usage
 * (`<svg lucideBox>`) and dynamic usage (`<svg [lucideIcon]="name">`).
 *
 * Includes LucideDynamicIcon so dynamic templates resolve through
 * provideLucideIcons.
 */
export const LUCIDE_ICONS = [LucideDynamicIcon, ...LUCIDE_ICON_SET];
